// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"698157c8","295":"19649fac","724":"493bf445","775":"e2ccf05d"}[chunkId] + ".chunk.js";
};